export type BrandTraitKey = (
    "bold"
    | "complex"
    | "fun"
    | "high-energy"
    | "human-warm"
    | "luxury"
    | "minimal"
    | "modern"
    | "precise"
    | "progressive"
    | "quiet"
    | "richly-textured"
    | "serious"
    | "traditional"
    | "inspiring"
    | "durable"
    );

export const BRAND_TRAIT_DEFINITIONS: { [key in BrandTraitKey]: { name: string, title: string } } = {
  "bold": {name: "bold", title: "Bold"},
  "complex": {name: "complex", title: "Complex"},
  "fun": {name: "fun", title: "Fun"},
  "high-energy": {name: "high-energy", title: "High Energy"},
  "human-warm": {name: "human-warm", title: "Human Warm"},
  "luxury": {name: "luxury", title: "Luxury"},
  "minimal": {name: "minimal", title: "Minimal"},
  "modern": {name: "modern", title: "Modern"},
  "precise": {name: "precise", title: "Precise"},
  "progressive": {name: "progressive", title: "Progressive"},
  "quiet": {name: "quiet", title: "Quiet"},
  "richly-textured": {name: "richly textured", title: "Richly Textured"},
  "serious": {name: "serious", title: "Serious"},
  "traditional": {name: "traditional", title: "Traditional"},
  "inspiring": {name: "inspiring", title: "Inspiring"},
  "durable": {name: "durable", title: "Durable"},
};


export function traitName(traitKey: BrandTraitKey) {
  return BRAND_TRAIT_DEFINITIONS[traitKey].name;
}

export function traitTitle(traitKey: BrandTraitKey) {
  return BRAND_TRAIT_DEFINITIONS[traitKey].title;
}
